import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import {
	buttonCouponAccountSX,
	containerCouponAccountSX,
	detailsCouponAccountSX,
	discountCouponAccountSX,
	labelCouponAccountSX,
	productCouponAccountSX,
	productImageCouponAccountSX,
	productTextCouponAccountSX,
	textCouponAccountSX,
	titleCouponAccountSX,
} from '@/components/blocks/DpLibrary/DpCouponAccount/styles';
import { Img } from '@/components/blocks/MaterialImage';
import { combineSX } from '@/utils/combineSX';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { MouseEvent } from 'react';
import { UrlObject } from 'url';

type DpCouponAccountProps = {
	name?: string;
	discount: string | number;
	expiration?: string;
	conditions?: string;
	label?: string;
	product?: string;
	image?: string;
	button?: string;
	href?: string | UrlObject;
	onClick?: (e: MouseEvent<HTMLElement>) => void;
	sx?: SxProps<Theme>;
};

/**
 * Tarjeta del cupón de recompra en Mi cuenta: descuento, vencimiento y la compra que lo generó.
 * Va debajo de los accesos de la cuenta, antes de "Resumen de tu cuenta".
 */
export const DpCouponAccount = ({
	name,
	discount,
	expiration,
	conditions = 'Un solo uso · Se aplica solo al pagar',
	label = 'Tu descuento personal',
	product,
	image,
	button = 'Ver mi selección',
	href,
	onClick,
	sx,
}: DpCouponAccountProps) => (
	<Box sx={combineSX([containerCouponAccountSX, ...(Array.isArray(sx) ? sx : [sx])])}>
		<Typography sx={discountCouponAccountSX}>
			{`${discount} `}
			<Typography component="span" fontSize="inherit" fontWeight="inherit">
				{'OFF'}
			</Typography>
		</Typography>
		<Box sx={textCouponAccountSX}>
			<Typography sx={labelCouponAccountSX}>{label}</Typography>
			<Typography sx={titleCouponAccountSX}>
				{`${name ? `${name}, tu` : 'Tu'} ${discount} OFF sigue activo`}
			</Typography>
			<Typography sx={detailsCouponAccountSX}>
				{expiration ? (
					<>
						{'Vence en '}
						<Typography component="strong" fontSize="inherit" fontWeight={700}>
							{expiration}
						</Typography>
						{conditions ? ' · ' : null}
					</>
				) : null}
				{conditions}
			</Typography>
		</Box>
		{product ? (
			<Box sx={productCouponAccountSX}>
				{image ? <Img src={image} alt={product} sx={productImageCouponAccountSX} /> : null}
				<Typography sx={productTextCouponAccountSX}>
					{'Lo ganaste con tu compra'}
					<br />
					<Typography component="strong" fontSize="inherit" fontWeight={700}>
						{product}
					</Typography>
				</Typography>
			</Box>
		) : null}
		<DpButton text={`${button} →`} href={href} onClick={onClick} sx={buttonCouponAccountSX} />
	</Box>
);
